<template>
  <div class="manage-gredit">
    <div class="data-info-box">
      <div class="top-flex">
        <div class="name-box">
          <div class="name-text">{{ staffName }}销售额</div>
          <div style="margin-top: 10px">
            <span class="money-text">{{ staffObject.monthSaleMoney }}</span>
            <span class="unit-text">元</span>
          </div>
        </div>
        <!-- <van-switch
					v-model="checked"
					active-color="#3377FF"
					size="25px"
				/> -->
      </div>
      <div style="margin-top: 30px; color: #333; font-size: 12px">
        <span>累计佣金：{{ staffObject.monthProfit }}元</span
        ><span style="margin-left: 30px"
          >订单：{{ staffObject.monthOrderNum }}单</span
        >
      </div>
    </div>
    <div class="step-box">
      <div class="line" style="color: #333"></div>
      <div class="flex1" style="font-size: 14px; margin-left: 4px">
        授信管理
      </div>
      <div style="font-size: 12px">
        当前可用余额：{{ staffObject.creditLimit }}元
      </div>
    </div>
    <div class="data-info-box" style="padding-top: 0px">
      <div class="cell-box">
        <div class="cell-title">授信类型</div>
        <van-popover
          v-model="showPopover"
          placement="bottom-end"
          trigger="click"
          :offset="[15, 10]"
          @select="selectOptions"
          :actions="actions"
        >
          <template #reference>
            <div style="color: #3377ff" @click="showPopover == true">
              {{ selectText }}
            </div>
          </template>
        </van-popover>
        <van-icon name="arrow-down" color="#3377FF" />
      </div>
      <div class="cell-box">
        <!-- <div class="cell-title"><span class="content">* </span>授信额度</div>
        <input
          class="text-number"
          type="number"
          v-model="creditValue"
          placeholder="输入授信额度"
        /> -->
        <van-field
          v-model="creditValue"
          required
          label="授信额度"
          placeholder="输入授信额度"
          style="paddingRight: 0px"
          class="remark-area"
        />
      </div>
      <div class="cell-box">
        <!-- <div class="cell-title"><span class="content">* </span>经办人</div> -->
        <!-- <input
          class="text-number text-margin"
          type="text"
          v-model="responsiblePerson"
          placeholder="收取充值款项的经办人"
        /> -->
        <van-field
          v-model="responsiblePerson"
          required
          label="经办人"
          placeholder="收取充值款项的经办人"
          style="paddingRight: 0px"
          class="remark-area"
        />
      </div>
      <div class="cell-box">
        <!-- <div class="cell-title"><span class="content">* </span>付款日期</div>
        <input
          class="text-number"
          type="text"
          v-model="paymentTime"
          placeholder="选择付款日期"
          readonly
          @click="handlePayShow"
        /> -->
        <van-field
          v-model="paymentTime"
          required
          label="付款日期"
          placeholder="选择付款日期"
          class="remark-area"
          @click="handlePayShow"
          readonly
        />
      </div>
      <div class="cell-box">
        <!-- <input
          class="text-number"
          type="textarae"
          v-model="remark"
          placeholder="输入备注说明"
        /> -->
        <van-field
          v-model="remark"
          rows="1"
          autosize
          label="备注说明"
          type="textarea"
          placeholder="请输入留言"
          style="padding: 10px 0px"
          class="remark-area"
          border
        />
      </div>
      <!-- <div class="cell-box">
        <div class="cell-title">授信状态</div>
        <van-switch v-model="checked" active-color="#3377FF" size="25px" />
      </div> -->
      <div class="box-button-text" @click="saveGredit">保存</div>
    </div>
    <van-calendar
      v-model="showCalendar"
      :default-date="selectedDate.toDate()"
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
import cateStepCard from "@/components/cate-step-card";
import dayjs from 'dayjs';

export default {
  components: { cateStepCard },
  data() {
    return {
      checked: false,
      number: 0,
      staffName: "",
      distributorId: "",
      creditValue: "",
      staffObject: {},
      showPopover: false,
      selectText: "增加",
      actions: [{ text: "增加" }, { text: "减少" }],
      responsiblePerson: "", // 经办人
      paymentTime: "", // 付款日期
      remark: "", // 备注说明
      showCalendar: false,
      selectedDate: dayjs(),
    };
  },
  methods: {
    saveGredit() {
      if (this.creditValue.length == 0) {
        this.$toast("请先输入授信额度！");
        return;
      }
      if (!this.responsiblePerson) {
        this.$toast("请先输入经办人！");
        return;
      }
      if (!this.paymentTime) {
        this.$toast("请先输入付款日期！");
        return;
      }
      var changeType = "5";
      if (this.selectText === "增加") {
        changeType = "4";
      }
      var params = {
        targetId: this.$route.query.staff.userId,
        // staffName: this.$route.query.staff.staffName,
        // distributorId: this.$route.query.staff.distributorsId,
        money: this.creditValue,
        chargeType: changeType,
        // distributorName: this.$route.query.staff.createBy,
        // oldQuota: this.staffObject.creditLimit,
        responsiblePerson: this.responsiblePerson,
        paymentTime: this.paymentTime,
        remark: this.remark,
        userLevel: 3
      };
      this.$API.x_person.setStaffCredit(params).then((res) => {
        this.$toast("设置成功");
        this.creditValue = "";
        this.responsiblePerson = "";
        this.paymentTime = "";
        this.remark = "";
        this.init();
      });
    },
    init() {
      this.$API.x_person
        .querySaleStatisticDtoDistributor({ distributorId: this.distributorId })
        .then((res) => {
          this.staffObject = res.data;
        });
    },
    selectOptions(value) {
      this.selectText = value.text;
    },
    handlePayShow() {
      this.showCalendar = true;
    },
    onConfirm(value) {
      this.paymentTime = dayjs(value).format('YYYY-MM-DD');
      this.showCalendar = false;
    },
  },
  mounted() {
    this.staffName = this.$route.query.staff.staffName;
    this.distributorId = this.$route.query.staff.userId;
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.manage-gredit {
  background-color: #f4f6f9;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: vw(30);
  .data-info-box {
    background-color: white;
    border-radius: vw(16);
    padding: vw(30);
  }
  .top-flex {
    display: flex;
    flex-direction: row;
    .name-box {
      flex: 1;
      color: $theme-color;
      .name-text {
        font-size: vw(32);
      }
      .money-text {
        font-size: vw(48);
      }
      .unit-text {
        font-size: vw(24);
      }
    }
  }
  .step-box {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .line {
      display: inline-block;
      width: vw(8);
      height: vw(36);
      border-radius: vw(4);
      background-color: $theme-color;
    }
  }
  .cell-box {
    border-bottom: 1px solid #f4f6f9;
    height: 50px;
    color: #333;
    font-size: vw(24);
    display: flex;
    flex-direction: row;
    align-items: center;
    .cell-title {
      flex: 1;
      .content {
        color: #F56C6C;
      }
    }
    .text-number {
      background-color: white;
      color: #333;
      text-align: end;
      border: none;
    }
    .text-margin {
      margin-right: 5px;
    }
  }
  .box-button-text {
    height: vw(88);
    line-height: vw(88);
    background-color: $theme-color;
    font-size: vw(30);
    font-family: Source Han Sans CN;
    color: #ffffff;
    border-radius: vw(8);
    text-align: center;
    margin-top: vw(30);
  }
}
.remark-area ::v-deep .van-field__control {
  text-align: right;
  color: #333;
  background-color: white;
}
.remark-area ::v-deep .van-field__control::-webkit-input-placeholder {
  text-align: right;
}
.cell-box ::v-deep .van-cell--required::before {
  left: 0px;
}
.remark-area {
  padding-left: 8px;
  padding-right: 0px;
}
</style>
